import Vue from 'vue'
import App from './App.vue'
// import vuetify from '@/plugins/vuetify' 
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '../public/fonts/Kanit/stylesheet.css'
import axios from 'axios'
import VueAxios from 'vue-axios'


Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(Vuetify)
new Vue({
  render: h => h(App),
}).$mount('#app')
